import { render, staticRenderFns } from "./deactivate.vue?vue&type=template&id=1b625784&"
import script from "./deactivate.vue?vue&type=script&lang=js&"
export * from "./deactivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports